import { z } from 'zod';
export const healthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded', 'down']),
    version: z.string(),
    checks: z.record(z.string(), z.enum(['ok', 'down'])).optional(),
});
//# sourceMappingURL=health.js.map